import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=7e90463c&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"
import style0 from "./Team.vue?vue&type=style&index=0&id=7e90463c&prod&lang=css"
import style1 from "./Team.vue?vue&type=style&index=1&id=7e90463c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e90463c",
  null
  
)

export default component.exports